module.exports = {
	"header": "Invoice",
	"create": "Create invoice",
	"created": "Invoice created!",
	"entryDescriptions": {
		"subscriptionRenewal": "Subscription renewal"
	},
	"entryTypes": {
		"subscription": "Subscription"
	},
	"invoiceParams": "Invoice parameters",
	"numberOfInvoices": "Number of invoices",
	"noInvoice": "No invoice.",
	"statuses": {
		"0": "Draft",
		"1": "Due",
		"2": "Overdue",
		"3": "Cancelled",
		"4": "Paid"
	},
	"types": {
		"draft": "Draft invoices",
		"due": "Due invoices",
		"paid": "Paid invoices",
		"cancelled": "Cancelled invoices"
	},
	"errors": {
		"oneItemMinimum": "You need to add at least one item to the invoice."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/invoice.json5
// module id = 1936
// module chunks = 6